module.exports = __webpack_public_path__ + "img/tg_03 (2).a2e999eb.jpg";